// Yemek tarihi tipi (Backend'den gelen yeni format)
export interface MealDate {
  date: string;
  userFeedback?: string | null;
}

// Temel yemek tipi (Backend Entity'ye uygun)
export interface Meal {
  id: number;
  title: string;
  description?: string;
  type: string;
  date?: string; // Frontend için geçici tarih alanı
  isActive?: boolean; // Frontend için geçici durum alanı
  dates?: MealDate[]; // Backend'den gelen gerçek format - artık object array
  company?: {
    id: number;
    name: string;
  };
  branch?: {
    id: number;
    name: string;
  };
  likes?: number;
  dislikes?: number;
  createdAt: string;
  updatedAt: string;
}

// Yemek türleri sabiti
export const mealTypes = [
  { value: 'soup', label: 'Çorba' },
  { value: 'main_course', label: 'Ana Yemek' },
  { value: 'dessert', label: 'Tatlı' },
  { value: 'salad', label: 'Salata' },
  { value: 'drink', label: 'İçecek' },
  { value: 'other', label: 'Diğer' }
];

// Yeni yemek oluşturma için DTO (API'ye uygun)
export interface CreateMealDto {
  title: string;
  description?: string;
  type: string;
  branch?: { id: number }; // API'de branch bilgisi gerekli
}

// Yemek güncelleme için DTO
export interface UpdateMealDto {
  title?: string;
  description?: string;
  type?: string;
  isActive?: boolean;
}

// Yemeği güne atama için DTO
export interface AssignMealToDateDto {
  date: string;
  branchId: number;
}

// Yemeği günden kaldırma için DTO
export interface RemoveMealFromDateDto {
  date: string;
}

// API response tipleri
export interface MealResponse {
  success: boolean;
  message?: string;
  data: Meal;
}

export interface MealsResponse {
  success: boolean;
  message?: string;
  data: Meal[];
}

// Yemek listesi için filtre tipi
export interface MealFilters {
  branchId?: number;
  startDate?: string;
  endDate?: string;
  search?: string;
}

// Tarih aralığı parametreleri
export interface MealDateRangeParams {
  startDate: string;
  endDate: string;
  branchId?: number;
}

// Belirli tarih parametreleri
export interface MealDateParams {
  date: string;
  branchId?: number;
}

// Yemek istatistikleri
export interface MealStats {
  totalMeals: number;
  activeMeals: number;
  inactiveMeals: number;
  mealsByDate: {
    [date: string]: number;
  };
}

// Form state tipleri
export interface MealFormData extends CreateMealDto {
  id?: number;
}

// Table/List görünümü için yemek tipi
export interface MealListItem {
  id: number;
  title: string;
  type: string;
  mealDates: MealDate[];
  branchName?: string;
  isActive: boolean;
  description?: string;
  createdAt: string;
}